import React from 'react';
import flogo from '../../media/flogo.png'
import bcorp from '../../media/2018-B-Corp-Logo-Black-XS.png'
import {Container, Row, Col, Stack, Image, Nav, NavLink} from "react-bootstrap";
 
const Footer = () => {
  const currentYear = new Date().getFullYear();
 
  return (
    <footer className="">
        <Container fluid style={{backgroundColor:'white'}}>
            <Row className="p-4">
                <Col className=''>
                   
                    <h5 className='text-center' style={{fontWeight: "bold", color:'rgb(120,120,120)'}}>Resources</h5>
                    <Nav className="fs-6 justify-content-center">
                        <NavLink href="https://enviro-stewards.com/privacy-policy/" target="_blank" style={{fontSize:'0.95rem'}}>Privacy Policy</NavLink>
                        <NavLink href="https://enviro-stewards.com/contact/" target="_blank" style={{fontSize:'0.95rem'}}>Contact Us</NavLink>
                    </Nav>
                </Col>
                <Col className='text-center'>
                <div className='justify-content-center'>
                    <Image
                        src={flogo}
                        alt="engineering change"
                        height={80}
                        style={{marginRight:'1vw'}}
                    />
                    <Image
                        src={bcorp}
                        alt="certified b corp"
                        height={80}
                        width={55}
                    />
                </div>
                   
                </Col>
            </Row>
            <Row>
                <p className="text-center text-xs text-gray-500" style={{fontSize:'0.8rem', color:'rgb(120, 120, 120)'}}>
                    © {currentYear} All rights reserved.
                </p>
            </Row>
        </Container>
    </footer>
  );
};
 
export default Footer;